<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2 track-anim">
              <div class="road">
                <!--Blue Truck-->

                <div class="blue_truck">
                  <div class="blue_truck_rim_one"></div>
                  <div class="blue_truck_rim_two"></div>
                </div>
                <!--Green Truck-->
                <div class="green_truck">
                  <div class="green_truck_rim_one"></div>
                  <div class="green_truck_rim_two"></div>
                </div>
              </div>
              <div class="bottom-grass"></div>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <div
                  class="vx-card__title mb-12 d-flex"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img src="/LogoFast.png" width="60px" alt="" />
                  <h1
                    style="font-size: 37px; font-weight: 700; margin-left: 10px"
                  >
                    Fastlogz
                  </h1>
                </div>
                <login-jwt></login-jwt>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import LoginJwt from "./components/LoginJWT.vue";

export default {
  components: {
    LoginJwt,
  },
};
</script>

<style lang="scss" scoped>
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
